import { FaturaOnaySeviye } from './fatura-onay-seviye';

export class FaturaFaturaOnaySeviye {
    faturaOnaySeviye: FaturaOnaySeviye;
    isOnay: boolean;
    
  
  
    constructor(obj?: any) {
      if (obj == null) {
        return;
      }
      Object.assign(this, obj);
      if (obj.faturaOnaySeviye != null) {
        this.faturaOnaySeviye = new FaturaOnaySeviye(obj.faturaOnaySeviye);
      }
    }
  
    get isOnayText(): string {
      if (this.isOnay == null) {
        return 'Onay Bekliyor';
      }
      if (this.isOnay) {
        return 'Onaylandı';
      }
      if (!this.isOnay) {
        return 'Reddedildi';
      }
      return '';
    }
}
